<span class="snack-message">
  {{ data }}
</span>
<!-- END! snack-message -->
